import { loadChart } from '@/common/utilities/nojq/_load.chart.js';

export default {
    name: 'mvtChart',
    props: {
        data: {
            default: () => null,
        },
        height: {
            default: () => null,
        },
        width: {
            default: () => null,
        },
    },
    methods: {
        destroyChart() {
            if (this._chartOb) {
                this._chartOb.destroy();
                this._chartOb = null;
            }
        },
        inital() {
            const canvas = this.$refs.canvas;
            if (!canvas || !this.chartData) {
                return;
            }
            const ctx = canvas.getContext('2d');
            if (this.height) {
                ctx.height = this.height;
            }
            if (this.width) {
                ctx.width = this.width;
            }
            loadChart().then((Chart) => {
                this.destroyChart();
                this._chartOb = new window.Chart(ctx, this.chartData);
            });
        },
        update(chartData) {
            // Recreate so options/plugins always match (partial update leaves stale skin config).
            this.destroyChart();
            if (!chartData || !this.$refs.canvas) {
                return;
            }
            this.inital();
        },
    },
    computed: {
        chartData() {
            return this.data;
        },
    },
    watch: {
        chartData(newVal) {
            this.update(newVal);
        },
    },
    mounted() {
        this.inital();
    },
    beforeUnmount() {
        this.destroyChart();
    },
};
